import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import RoomDetailsForm from "../../../components/forms/setup/rooms/RoomDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function RoomsViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [rooms, setRooms] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getRooms = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `rooms?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setRooms(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createRoom = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("rooms/create", payload);

    if (callResult.success) {
      showSuccess("Room added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getRooms("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateRoom = async function (values, index) {
    let callResult = await makePutApiCall(`rooms/${values.id}`, values);

    if (callResult.success) {
      showSuccess("Room updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...rooms.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setRooms({ ...rooms, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddRoomSlideOver = (isEdit, room, index) => {
    setSlideOver({
      childComponent: (
        <RoomDetailsForm
          room={room}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateRoom(payload, index) : createRoom(payload)
          }
          title={isEdit ? `Update ${room.name}` : "Add new room"}
        />
      ),
      open: true,
    });
  };

  const deleteRoom = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteRoom/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = rooms.data.filter((item) => item.id !== id);
      setRooms({ ...rooms, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteRoom = function (room, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteRoom(room.id, index)}
          message={`Are you sure you want to delete  ${room.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddRoomSlideOver,
    getRooms,
    loading,
    rooms,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteRoom,
  };
}
